export default {
    Frequency: 1,
    SchoolIntegration: 2,
    Location: 3,
    Condition: 4,
    KeepNextYear: 5,
    FromOtherSchool: 6,
    KeepUsing: 7,
} 